export default __webpack_public_path__ + "static/media/ICONOS INGLÉS  MI SEGURO SOMIT -08.120bd532.png";